import { render, staticRenderFns } from "./HumanCostList.vue?vue&type=template&id=4704bb48&scoped=true&"
import script from "./HumanCostList.vue?vue&type=script&lang=js&"
export * from "./HumanCostList.vue?vue&type=script&lang=js&"
import style0 from "./HumanCostList.vue?vue&type=style&index=0&id=4704bb48&lang=less&scoped=true&"
import style1 from "./HumanCostList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4704bb48",
  null
  
)

export default component.exports